export const isDev = () => process.env.NODE_ENV === 'development';

export const isProduction = () =>
  process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';
